import { render } from "./ScoreCounter.vue?vue&type=template&id=47dfc71b"
import script from "./ScoreCounter.vue?vue&type=script&lang=js"
export * from "./ScoreCounter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__